export default __webpack_public_path__ + "static/media/ytLogo.0b8cd636.png";